var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left welcome"},[_c('span',[_vm._v(" "+_vm._s(_vm.greeting)+"， ")]),_c('span',{staticStyle:{"color":"#1890ff"}},[_vm._v(" "+_vm._s(_vm.userName)+"， ")]),_c('span',[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }